import * as Utils from './lsg-utils';
import { processAndAddToCart } from './lsg-cart-handler';
import Flickity from 'flickity';


const recommendationsEls    = document.querySelectorAll(`[lsg-recommendations]`),
      baseURL               = `${window.Shopify.routes.root}recommendations/products.json`,
      debug                 = false;

recommendationsEls.forEach((recommendationsEl) => {
    const productId = recommendationsEl.getAttribute(`lsg-recommendations-product-id`);

    processRecommendations(productId, recommendationsEl);
});

async function processRecommendations(productId, recommendationsEl) {
    const productIdParam    = `product_id=${productId}`,
          limitParam        = `limit=${recommendationsEl.getAttribute(`lsg-recommendations-limit`)}`,
          intentParam       = `intent=${recommendationsEl.getAttribute(`lsg-recommendations-intent`)}`,
          productData       = await Utils.apiCall('GET', `${baseURL}?${productIdParam}&${limitParam}&${intentParam}`);

    // Gather metadata
    /**
     * We have to use a hidden template to generate JSON for fetching metafields.
     * URL: /products/${productHandle}?view=lsg-metafields
     */
    const promises = [];
    productData.products.forEach((product) => {
        const metafieldsURL = `/products/${product.handle}?view=lsg-metafields`;
        promises.push(
            Utils.apiCall('GET', metafieldsURL)
                .then((response) => {
                    if (debug) console.log(`[LSG] response:`, response);
                    product.metafields = response;
                })
        );
    });

    Promise.all(promises).then(() => {
    
        if (debug) console.log(`[LSG] Processing recommendations, productId:`, productId);
        if (debug) console.log(`[LSG] productData:`, productData);
    
        const cloneEls = renderProducts(productData.products, recommendationsEl);
        updateCarousel(cloneEls, recommendationsEl);

    });
}

function updateCarousel(cloneEls, recommendationsEl) {
    const blockId           = recommendationsEl.getAttribute(`data-block-id`),
          carouselSettings  = JSON.parse(document.getElementById(`CarouselSettings-${blockId}`).textContent),
          wrapperEl         = recommendationsEl.querySelector(`.lsg-mini-upsell-carousel__wrapper`);

    if (debug) console.log(`[LSG] cloneEls:`, cloneEls);
    if (debug) console.log(`[LSG] cloneEls.length:`, cloneEls.length);

    /* Carousel Settings */
    // carouselSettings.setGallerySize = true;
    carouselSettings.imagesLoaded   = true;
    
    /* Get current carousel instance */
    let carouselEl = Flickity.data(wrapperEl);

    /* Situational handling of carousel */
    if (typeof carouselEl != 'undefined') {

        if (debug) console.log(`[LSG] Update existing carousel.`);

        const cellsArr  = carouselEl.cells,
              cellEls   = [];
        cellsArr.forEach((cell) => {
            cellEls.push(cell.element);
        });
        carouselEl.remove(cellEls);

        if (cloneEls.length < 1) {
            if (debug) console.log(`[LSG] No recommendations, destroying carousel.`);
            carouselEl.destroy();
            recommendationsEl.classList.add(`lsg-mini-upsell-carousel-inactive`);
        } else {
            carouselEl.append(cloneEls);
            carouselEl.select(0, false, true);
        }
    } else if (cloneEls.length > 0) {

        if (debug) console.log(`[LSG] New carousel.`);

        cloneEls.forEach((cloneEl) => {
            wrapperEl.appendChild(cloneEl);
        });

        recommendationsEl.classList.remove(`lsg-mini-upsell-carousel-inactive`);
        carouselEl = new Flickity(wrapperEl, carouselSettings);

    } else {

        if (debug) console.log(`[LSG] No recommendations.`);

        recommendationsEl.classList.add(`lsg-mini-upsell-carousel-inactive`);
    }
}

function renderProducts(products, recommendationsEl) {
    const blockId           = recommendationsEl.getAttribute(`data-block-id`),
          truncateToggle    = recommendationsEl.getAttribute(`lsg-recommendations-truncate`),
          controlsClass     = recommendationsEl.getAttribute(`lsg-recommendations-controls-class`),
          templateEl        = document.querySelector(`template[data-block-id="${blockId}"]`),
          cloneEls          = [];

    /**
     * Build Product Slides
     */
    products.forEach((product) => {
        const cloneEl           = templateEl.content.firstElementChild.cloneNode(true),
              cloneImgEl        = cloneEl.querySelector(`img`),
              cloneTitleGroupEl = cloneEl.querySelector(`.lsg-mini-upsell-carousel-slide__title-group`),
              cloneTitleEl      = cloneEl.querySelector(`.lsg-mini-upsell-carousel-slide__title`),
              cloneDescEl       = cloneEl.querySelector(`.lsg-mini-upsell-carousel-slide__description`),
              clonePriceEl      = cloneEl.querySelector(`.lsg-mini-upsell-carousel-slide__price`),
              cloneFormEl       = cloneEl.querySelector(`.shopify-product-form`);

        // Product Title
        let productTitle;
        if (typeof product.metafields.upsell_title_override !== 'undefined') {
            productTitle = product.metafields.upsell_title_override;
        } else if (truncateToggle === `true`) {
            productTitle = Utils.truncateString(product.title, 20);
        } else {
            productTitle = product.title;
        }

        // Description
        let description;
        if (typeof product.metafields.over_title_text !== 'undefined') {
            description = product.metafields.over_title_text;
        }

        // Product Notice
        if (typeof product.metafields.upsell_notice !== 'undefined') {
            const noticeEl = document.createElement(`div`);

            noticeEl.textContent = product.metafields.upsell_notice;
            noticeEl.classList.add(`lsg-caption`);
            noticeEl.classList.add(`lsg-mini-upsell-carousel-slide__notice`);

            cloneTitleGroupEl.appendChild(noticeEl);
        }

        // Product Price
        let productPrice;
        if (product.compare_at_price && product.compare_at_price !== product.price && product.compare_at_price !== 0) {
            let regPrice    = `<span style="text-decoration: line-through;">${Utils.formatter.format(product.compare_at_price / 100)}</span>`
            let salePrice   = `<strong>${Utils.formatter.format(product.price / 100)}</strong>`
            productPrice = `${regPrice} - ${salePrice}`;
        } else {
            productPrice = Utils.formatter.format(product.price / 100);
        }

        // Product Image
        cloneImgEl.src = Utils.imgURL(product.media[0].src, 'medium');
        if (typeof product.metafields.cart_slide_product_image !== 'undefined') {
            cloneImgEl.src = product.metafields.cart_slide_product_image;
        }
        cloneTitleEl.innerHTML = productTitle;
        if (typeof description !== 'undefined') {
            cloneDescEl.innerHTML = description;
        }
        clonePriceEl.innerHTML = productPrice;
        cloneFormEl.setAttribute(`id`, `product_form_${product.id}`);
        cloneFormEl.setAttribute(`data-productid`, product.id);

        // Build variants list
        const actualVariants = [];
        if (debug) console.log(`[LSG] product.id:`, product.id);
        product.variants.forEach((variant) => {
            if (debug) console.log(`[LSG] variant:`, variant);
            const variantMetafields = product?.metafields?.variants?.find(v => v.id === parseInt(variant.id));
            if (debug) console.log(`[LSG] variantMetafields:`, variantMetafields);
            const sellingPlanOnly = variantMetafields?.selling_plan_only
            if (debug) console.log(`[LSG] sellingPlanOnly:`, sellingPlanOnly);
            if (typeof sellingPlanOnly === 'undefined' || sellingPlanOnly === false) {
                actualVariants.push(variant);
            }
        });
        if (debug) console.log(`[LSG] actualVariants:`, actualVariants);

        // Product ATC Form & Controls
        if (actualVariants.length === 1) {
            const inputEl = document.createElement(`input`);
            inputEl.setAttribute(`type`, `hidden`);
            inputEl.setAttribute(`name`, `id`);
            inputEl.setAttribute(`value`, product.variants[0].id);
            cloneFormEl.appendChild(inputEl);

            const btnEl = document.createElement(`button`);
            btnEl.setAttribute(`type`, `submit`);
            btnEl.classList.add(`lsg-button`, `lsg-button__style-1`, controlsClass);
            btnEl.innerHTML = `<span>+</span><span>Add</span>`;
            cloneFormEl.appendChild(btnEl);
        } else {
            const selectWrapperEl = document.createElement(`div`);
            selectWrapperEl.classList.add(`lsg-select-wrapper`);

            const selectEl = document.createElement(`select`);
            selectEl.setAttribute(`name`, `id`);
            selectEl.setAttribute(`id`, `productSelect-${product.id}`);
            selectWrapperEl.appendChild(selectEl);

            const firstOptionEl = document.createElement(`option`);
            firstOptionEl.textContent = `SELECT AN OPTION`;
            selectEl.appendChild(firstOptionEl);

            actualVariants.forEach((variant) => {
                const optionEl = document.createElement(`option`);
                optionEl.setAttribute(`value`, variant.id);

                let variantTitle;
                if (variant.available) {
                    variantTitle = `${variant.title} - ${Utils.formatter.format(variant.price / 100)}`;
                } else {
                    optionEl.setAttribute(`disabled`, true);
                    variantTitle = `${variant.title} - Sold Out`;
                }
                optionEl.textContent = variantTitle;

                selectEl.appendChild(optionEl);
            });

            cloneFormEl.appendChild(selectWrapperEl);
        }

        // Handle "Upsell As Subscription"
        if (typeof product.metafields.upsell_as_subscription !== 'undefined' && product.metafields.upsell_as_subscription) {

            if (debug) console.log(`[LSG] Product is 'upsell as subscription'.`);

            const inputEl = document.createElement(`input`);
            inputEl.setAttribute(`type`, `hidden`);
            inputEl.setAttribute(`name`, `selling_plan`);

            product.variants[0].selling_plan_allocations.find((spa) => {
                const spgs  = product.selling_plan_groups.find(g => g.id === spa.selling_plan_group_id),
                      sp    = spgs.selling_plans.find(sp => sp.id === parseInt(spa.selling_plan_id));

                if (debug) console.log(`[LSG] spgs.app_id:`, spgs.app_id);
                if (debug) console.log(`[LSG] product.metafields.subscription_app_id:`, product.metafields.subscription_app_id);

                if (parseInt(spgs.app_id) === product.metafields.subscription_app_id)
                {
                    if (debug) console.log(`[LSG] spgs:`, spgs);
                    if (debug) console.log(`[LSG] sp:`, sp);
        
                    inputEl.setAttribute(`value`, sp.id);

                    return true;
                }
            });

            cloneFormEl.appendChild(inputEl);
        }

        // Form Submit Handler
        cloneFormEl.addEventListener('submit', (e) => {
            e.preventDefault();
            const formData  = new FormData(e.target);
            processAndAddToCart(formData, cloneFormEl);
        });

        // Select Change Handler
        const formSelectEl = cloneFormEl.querySelector(`select`);
        if (formSelectEl) {
            formSelectEl.addEventListener(`change`, e => {
                // Need a better hook here, this is temporary
                if (formSelectEl.value !== `SELECT AN OPTION`) {
                    cloneFormEl.requestSubmit();
                }
            });
        }
        
        // Store Slide
        cloneEls.push(cloneEl);

    });
    
    return cloneEls;
}

export function refreshRecommendations(productId) {
    if (debug) console.log(`[LSG] Refreshing recommendations, productId:`, productId);
    recommendationsEls.forEach((recommendationsEl) => {
        processRecommendations(productId, recommendationsEl);
    });
}